import * as React from "react";
import LoginService from "../../../service/login/loginService";
import PlanOverviewMob from "./PlanOverviewMob";
import {toINR} from "../../../service/numberFormat";
import EdButton from "../../../generic/edButton";
import {IPContext} from "../../infinityPlan";
import gtmService from "../../../service/gtmService";

export default function PlanAllDetailsMob() {
    const {selectedPlan,setShowAllPlan,saveLead,setShowModal} = React.useContext(IPContext);
    const [loggedIn] = React.useState<boolean>(LoginService.isLoggedIn());
    const [infinityPlanFlag] = React.useState<boolean | undefined>(LoginService.getAccData("accs")?.mfInf);
    return (
        <>
            {selectedPlan && (
                <>
                    <ul className="plans_grid">
                        <li className={selectedPlan.color}>
                            {PlanOverviewMob(selectedPlan, setShowAllPlan)}
                            <label className="row-label">All Brokerage Rates</label>
                            <div className="row5 two-col-row">
                                <div>
                                    <label className="row_lbl">Cash Delivery</label>
                                    <label className="row_val">{selectedPlan.cash_delivery}</label>
                                </div>
                                <div>
                                    <label className="row_lbl">Intraday & Eq Futures </label>
                                    <label className="row_val">{selectedPlan.intraday_eq_fut}</label>
                                </div>
                                <div>
                                    <label className="row_lbl">Option Per Lot </label>
                                    <label className="row_val">{selectedPlan.option_per_lot}</label>
                                </div>
                                <div>
                                    <label className="row_lbl">CDS Future </label>
                                    <label className="row_val">{selectedPlan.cds_future}</label>
                                </div>
                                <div>
                                    <label className="row_lbl">CDS Option Per Lot </label>
                                    <label className="row_val">{selectedPlan.cds_option_per_lot}</label>
                                </div>
                            </div>
                            <label className="row-label">Assumptions In Calculating Total Benefit</label>
                            <div className="row6 pd-b20 two-col-row">
                                <div>
                                    <label className="row_lbl">Delivery Volume Rs</label>
                                    <label className="row_val">
                                        <b>₹</b>
                                        {selectedPlan.delivery_volume_rs}
                                    </label>
                                </div>
                                <div>
                                    <label className="row_lbl">Monthly SIP Amount </label>
                                    <label className="row_val">
                                        <b>₹</b>
                                        {toINR(selectedPlan.monthly_sip_amount)}
                                    </label>
                                </div>
                                <div>
                                    <label className="row_lbl">Minimum Current MF Investment Amount </label>
                                    <label className="row_val">
                                        <b>₹</b>
                                        {toINR(selectedPlan.min_cur_mf_inv)}
                                    </label>
                                </div>
                                <div>
                                    <label className="row_lbl">Average Debit in Margin Trading </label>
                                    <label className="row_val">
                                        {selectedPlan.avg_debit_margin_trading ? (
                                            <>
                                                <b>₹</b>
                                                {toINR(selectedPlan.avg_debit_margin_trading)}
                                            </>
                                        ) : (
                                            "-"
                                        )}
                                    </label>
                                </div>
                                <div>
                                    <label className="row_lbl avg_fno_col">
                                        Average FNO Margin requirement (FNO positions against pledged stocks){" "}
                                    </label>
                                    <label className="row_val">
                                        {selectedPlan.avg_fno_margin ? (
                                            <>
                                                <b>₹</b>
                                                {toINR(selectedPlan.avg_fno_margin)}
                                            </>
                                        ) : (
                                            "-"
                                        )}
                                    </label>
                                </div>
                            </div>
                        </li>

                        {!infinityPlanFlag && (
                            <li className="plans_n_pricing_ftr grid_cols fixed">
                                <div className="row7 two-col-row">
                                    <div className="tb-col-text">
                                        <label className="total_benefits row_lbl">Total Benefits</label>

                                        <div className="total_benefits_val">
                                            <b>₹</b>
                                            {toINR(selectedPlan.total_benefits)}
                                        </div>

                                        {/* <label className="row_val2 row_val">500000</label> */}
                                    </div>

                                    <EdButton
                                        btnTyp="primary"
                                        value="I’m Interested"
                                        className="ed_button ib primary button"
                                        onClick={() => {
                                            gtmService({
                                                event: "event Infinity_Subscription_Program",
                                                category: "Infinity Subscription",
                                                action: "Footer_button",
                                                labelUrlR: "I'm Interested"
                                            });
                                            loggedIn ?saveLead() : setShowModal(true);
                                        }}
                                        slim
                                    />
                                </div>
                            </li>
                        )}
                    </ul>
                </>
            )}
        </>
    );
}

